import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';
import classNames from 'classnames/bind';

// Utils
import { isToday } from '../../../utils/helpers';
import parseISO from '../../../utils/parseISO';

// Components
import Button from '../../Button';
import OrderPreview from '../../OrderPreview';
import OrderItemDescription from '../../OrderItemDescription';

// Styles
import styles from './CompactView.styl';

const cx = classNames.bind(styles);

export default function CompactView(props) {
  const {
    className,
    client_number,
    date,
    cart: { composition, discount_price },
    isAdding,
    addToCart,
    id,
  } = props;

  const parsedDate = parseISO(date);

  const handleAddToCart = () => addToCart(id, composition);

  return (
    <div className={cx('OrderItem', className)}>
      <div className={cx('OrderItem__preview')}>
        <OrderPreview items={composition} />
      </div>
      <div className={cx('OrderItem__info')}>
        <div className={cx('OrderItem__header')}>
          <div className={cx('OrderItem__date')}>
            {isToday(parsedDate) ? (
              <FormattedMessage id="date.today.label" />
            ) : (
              <FormattedDate value={parsedDate} year="numeric" month="long" day="2-digit" />
            )}
          </div>
          <div className={cx('OrderItem__number')}>№ {client_number}</div>
        </div>
        <div className={cx('OrderItem__description')}>
          <OrderItemDescription composition={composition} />
        </div>
      </div>
      <div className={cx('OrderItem__actions')}>
        <Button
          onClick={handleAddToCart}
          small
          isLoading={isAdding}
          disabled={discount_price === 0}
        >
          <FormattedMessage id="button.repeat" />
        </Button>
      </div>
    </div>
  );
}

CompactView.defaultProps = {
  className: '',
  isAdding: false,
};

CompactView.propTypes = {
  className: PropTypes.string,
  isAdding: PropTypes.bool,
  client_number: PropTypes.string,
  cart: PropTypes.object.isRequired,
  date: PropTypes.string,
  id: PropTypes.number.isRequired,
  addToCart: PropTypes.func.isRequired,
};
